export const getMinValueInArray = (data, key) => {
  return Math.min.apply(
    Math,
    data.map((dataComponent) => {
      return dataComponent[key];
    })
  );
};

export const getMaxValueInArray = (data, key) => {
  return Math.max.apply(
    Math,
    data.map((dataComponent) => {
      return dataComponent[key];
    })
  );
};
